import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-750aeb60")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_loader = _resolveComponent("s-loader")!

  return (_openBlock(), _createBlock("button", {
    class: "NewButton",
    disabled: _ctx.disabled,
    type: _ctx.type,
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitClick && _ctx.emitClick(...args)))
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_s_loader, { key: 0 }))
      : _renderSlot(_ctx.$slots, "default", { key: 1 }, undefined, true)
  ], 8, ["disabled", "type"]))
})